export const ADDED_TO_BAG_EVENT_LOCATION = "bag_modal";
export const MODAL_VIEW_TARGET = "bag";
